export default async function GetUser() {
    
    // let url =window.UserbaseUrl+"/api/SubApplicationRequest/GetSubApplicationRequest";
    let url ="http://172.16.61.31:7098/api/SubApplicationRequest/GetSubApplicationRequest";
    let head={ 'Content-Type': 'application/json-patch+json'};
    let response = await fetch(url,{
      method: "GET",
      headers: head
    }).then((res) => res.json());
    return response;
  }
